export const CONFIDENTIALITY_PROMISE = 'https://workbuzz.com/confidentiality-promise/';
export const CONFIDENTIALITY_PROMISE_LIFECYCLE =
  'https://workbuzz.com/confidentiality-promise/lifecycle/';
export const GOOGLE_ADVERTISING_PRODUCTS = 'https://policies.google.com/technologies/cookies';
